const styles = {
  marginBottom: {
    marginBottom: '1rem'
  },
  marginRight: {
    marginRight: '2.5rem'
  }
};

export default styles;